<template>
	<div v-if="passes" class="w-100">
		<div class="container-fluid px-0 mx-0">
			<div class="grid-wrapper">
				<div v-for="pass in passes" :key="pass.id">
					<div class="pass-container" @click="openedPass = pass">
						<div class="image">
							<ding-image v-if="pass.image?.file_name" :src="context.storageEndpoint + pass.image?.file_name"
								aspect-ratio="1:1" width="100%" />
							<div v-if="hasSoldOut(pass)" class="icon-sold-out-container">
								<div class="icon-sold-out">{{ $t('sold_out') }}</div>
							</div>
						</div>
						<div class="py-1 px-2 pass-name"><small><b>{{ pass.title }}</b></small></div>
						<div class="flex-grow-1"></div>
						<div class="pb-1 px-2">
							<small :style="{ color: provider.theme_tint_hex }"><b>{{ getExchangedAmount(pass.price) }}</b></small>
						</div>
					</div>
				</div>
			</div>
			<pass-viewer
				v-if="openedPass"
				:context="context"
				:provider="provider"
				:pass="openedPass"
				@close="openedPass = null"
			/>
		</div>
	</div>
</template>

<script>
import promptAlert from '../../mixins/prompt-confirm';
import DingImage from '../common/Image';
import { mapGetters, mapActions } from 'vuex';
import PassViewer from '../PassViewer';
import RootStore from '../../stores/root';
import { getExchangedAmount } from '../../bu/CurrencyUtils';

export default {
	store: RootStore,
	components: { DingImage, PassViewer },
	mixins: [promptAlert],
	props: {
		serviceId: { required: true },
		context: { type: Object, required: true },
		provider: { type: Object, required: true },
	},
	data() {
		return {
			openedPass: null
		};
	},
	computed: {
		...mapGetters({
			passes: 'booking-passes/bookingPasses',
			currency: 'currencies/currency',
			currencyRateMap: 'currencies/currencyRateMap',
			currencyOptions: 'currencies/currencyOptions',
		}),
	},
	methods: {
		...mapActions({
			getServiceRelatedBookingPasses: 'booking-passes/getServiceRelatedBookingPasses'
		}),
		passImagePath(pass) {
			return this.context.storageEndpoint + pass.image_path;
		},
		hasSoldOut(pass) {
			return pass.total_issueable_count - pass.total_issued_count <= 0;
		},
		getExchangedAmount(amount) {
			return getExchangedAmount({
				rateMap: this.currencyRateMap,
				amount,
				from: this.provider.currency || 'TWD',
				to: this.currency,
				currencyOptions: this.currencyOptions,
			});
		},
	},
	async mounted() {
		try {
			await this.getServiceRelatedBookingPasses(this.serviceId);
		} catch (e) {
			this.promptAlert(this.$t('booking_passes.fail_to_get_related_booking_passes'))
		}
	},
}
</script>

<style scoped>
	.pass-container {
		height: 100%;
		margin-bottom: 8px;
		box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.30);
		overflow: hidden;
		border-radius: 4px;
		cursor: pointer;
		display: flex;
		flex-direction: column;
	}

	.grid-wrapper {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-column-gap: 8px;
		grid-row-gap: 8px;

		@media screen and (min-width: 576px) {
			grid-template-columns: repeat(3, 1fr);
			grid-column-gap: 16px;
			grid-row-gap: 16px;
		}
	}
	.pass-name {
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 1.2em;
		display: inline-block;
	}
	
	.remaining-stock{
		font-size: 12px;
		color: #666;
	}

	.image {
		overflow: hidden;
		position: relative;
	}

	/deep/ .pass-container .image > div:first-child {
		transform: scale(1);
		overflow: hidden;
		transition-property: transform;
		transition-duration: 0.5s;
	}

	/deep/ .pass-container .image:hover {
		& > div:first-child {
			transform: scale(1.2);
		}
	}

	.flex-grow-1 {
		flex-grow: 1;
	}

	.icon-sold-out-container {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		display: block;
		background: rgba(255, 255, 255, 0.4);
	}
	
	.icon-sold-out {
		background: rgba(0, 0, 0, 0.7);
		margin-top: calc(50% - 40px);
		border-radius: 4px;
		font-size: 14px;
		color: white;
		display: inline-block;
		position: absolute;
		bottom: 4px;
		right: 4px;
		padding: 2px 10px;
	}
	
	.icon-time-limit {
		background: rgba(19, 169, 211, 0.7);
		border-radius: 4px;
		font-size: 14px;
		color: white;
		display: inline-block;
		position: absolute;
		top: 4px;
		left: 4px;
		padding: 2px 10px;
		font-weight: bold;
	}
</style>
